import React from 'react'

interface ChevronDownIconProps {
  color?: string
  size?: number
}

/**
 * Chevron down icon for expanded state
 */
const ChevronDownIcon: React.FC<ChevronDownIconProps> = ({
  color = '#797B7E',
  size = 24,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M15.8751 9.00051L11.9951 12.8805L8.1151 9.00051C7.7251 8.61051 7.0951 8.61051 6.7051 9.00051C6.3151 9.39051 6.3151 10.0205 6.7051 10.4105L11.2951 15.0005C11.6851 15.3905 12.3151 15.3905 12.7051 15.0005L17.2951 10.4105C17.6851 10.0205 17.6851 9.39051 17.2951 9.00051C16.9051 8.62051 16.2651 8.61051 15.8751 9.00051Z'
        fill={color}
      />
    </svg>
  )
}

export default ChevronDownIcon
